import axios from './axiosConfig';
import { getItem } from './localStorageUtil';
import { FXZ_API_URI_PREFIX, NEWAPI_API_URI_PREFIX } from './fxzApiService';
import { TOKEN_KEY } from '../const/localStorageConst';
import { isForceUpdatePasswordRequired } from './forcePasswordUpdate';
import { requestPasswordUpdate } from './passwordUpdateBus';

/**
 * 需要自动携带 token 的请求前缀列表
 * 匹配到的路由会自动在请求头中添加 token 字段，
 * 并在收到 403 响应时自动清除本地 token
 */
const TOKEN_REQUIRED_PREFIXES = [FXZ_API_URI_PREFIX, NEWAPI_API_URI_PREFIX];

/**
 * 判断当前请求前缀是否需要携带 token
 */
function needsToken(prefixUri) {
  return TOKEN_REQUIRED_PREFIXES.includes(prefixUri);
}

/** 强制修改密码时仍允许调用的接口 */
const FORCE_PASSWORD_EXEMPT_URIS = [
  '/user/get_auth_token', '/user/update_current_pwd', '/auth/iamOAuth', '/user/fullwork_auth_login',
  '/user/get_user_info', '/user/portal_heartbeat', '/user/portal_presence', '/user/logout'
];

/**
 * 如果本地标记要求强制修改密码，则阻断除白名单外的接口请求
 */
function blockRequestIfPasswordUpdateRequired(uri, cb) {
  if (!getItem(TOKEN_KEY) || !isForceUpdatePasswordRequired() || FORCE_PASSWORD_EXEMPT_URIS.includes(uri)) {
    return false;
  }

  requestPasswordUpdate({ forced: true, source: 'api-block' });
  if (cb) {
    cb({
      status: 0,
      code: 'FORCE_UPDATE_PASSWORD',
      msg: '请先修改密码后继续使用'
    });
  }
  return true;
}

/**
 * POST 请求封装
 * @param {string} prefixUri - 接口前缀（如 FXZ_API_URI_PREFIX、NEWAPI_API_URI_PREFIX）
 * @param {string} uri - 接口路径（如 '/user/list'）
 * @param {object} params - 请求体参数
 * @param {function} cb - 回调函数，接收响应数据；请求失败时也会调用，返回 { status: 0, msg: '...' }
 *
 * 403 处理由 axiosConfig.js 响应拦截器统一负责：
 * 清除 token → 跳转登录页（/fuxiaozhu/login）
 */
export function postHttp(prefixUri, uri, params, cb){
    // 强制修改密码未完成时，阻断除登录/修改当前密码以外的接口
    if (blockRequestIfPasswordUpdateRequired(uri, cb)) {
      return;
    }

    let config = {};
    uri = prefixUri + uri;
    // 如果是需要 token 的接口，自动添加 token header
    if (needsToken(prefixUri)){
      const token = getItem(TOKEN_KEY);
      if (token) {
        config.headers = { 'token': token };
      }
    }
    axios.post(uri, params, config)
      .then((response)=>{
        if(response && response.status === 200){
          if(cb){
            cb(response.data)
          }
        }
      })
      .catch((error)=>{
        console.log("POST请求失败:", error);
        // 请求失败时仍然调用回调，避免 Promise 永远不 resolve 导致页面卡死
        if (cb) {
          cb({ status: 0, msg: '网络请求失败，请检查网络后重试' });
        }
    });
}

/**
 * GET 请求封装
 * @param {string} prefixUri - 接口前缀
 * @param {string} uri - 接口路径
 * @param {object} params - 查询参数（会拼接到 URL）
 * @param {function} cb - 回调函数，接收响应数据；请求失败时也会调用，返回 { status: 0, msg: '...' }
 *
 * 403 处理由 axiosConfig.js 响应拦截器统一负责：
 * 清除 token → 跳转登录页（/fuxiaozhu/login）
 */
export function getHttp(prefixUri, uri, params, cb) {
  // 强制修改密码未完成时，阻断除登录/修改当前密码以外的接口
  if (blockRequestIfPasswordUpdateRequired(uri, cb)) {
    return;
  }

  let config = { params };
  uri = prefixUri + uri;
  // 如果是需要 token 的接口，自动添加 token header
  if (needsToken(prefixUri)) {
    const token = getItem(TOKEN_KEY);
    if (token) {
      config.headers = { 'token': token };
    }
  }
  axios.get(uri, config)
    .then((response) => {
      if (response && response.status === 200) {
        if (cb) {
          cb(response.data);
        }
      }
    })
    .catch((error) => {
      console.log("GET请求失败:", error);
      // 请求失败时仍然调用回调，避免 Promise 永远不 resolve 导致页面卡死
      if (cb) {
        cb({ status: 0, msg: '网络请求失败，请检查网络后重试' });
      }
    });
}




